import React, { useCallback, useEffect, useMemo, useState } from 'react';
import SiteMapPopup from '../admin/site-map/SiteMapPopup';
import SalesLocationSelectModal from './SalesLocationSelectModal';

const STEP = {
  SALES_LOCATION: 'salesLocation',
  MAP: 'map'
};

const SiteMapUnitPicker = ({ show, onHide, onUnitSelect, excludedUnitIds = [], appChoices = [] }) => {
  const [step, setStep] = useState(STEP.SALES_LOCATION);
  const [selectedSalesLocation, setSelectedSalesLocation] = useState(null);
  const [selectedSubLocation, setSelectedSubLocation] = useState(null);

  const salesLocations = useMemo(
    () => appChoices.find(choice => choice.key === 'salesLocation')?.values || [],
    [appChoices]
  );

  const resetState = useCallback(() => {
    setStep(STEP.SALES_LOCATION);
    setSelectedSalesLocation(null);
    setSelectedSubLocation(null);
  }, []);

  useEffect(() => {
    if (!show) {
      resetState();
    }
  }, [show, resetState]);

  const handleClose = () => {
    resetState();
    onHide();
  };

  const onSiteSelect = (site, salesLocation) => {
    setSelectedSubLocation(site);
    setSelectedSalesLocation(salesLocation);
    setStep(STEP.MAP);
  };

  const onSiteMapHide = () => {
    setStep(STEP.SALES_LOCATION);
    setSelectedSubLocation(null);
  };

  const onSiteUpdate = updatedSite => {
    setSelectedSubLocation(updatedSite);
  };

  const defaultExpandedLocationId =
    step === STEP.SALES_LOCATION && selectedSalesLocation?._id ? selectedSalesLocation._id : null;

  return (
    <>
      <SalesLocationSelectModal
        show={show && step === STEP.SALES_LOCATION}
        onHide={handleClose}
        salesLocations={salesLocations}
        onSiteSelect={onSiteSelect}
        defaultExpandedLocationId={defaultExpandedLocationId}
      />

      <SiteMapPopup
        show={show && step === STEP.MAP && Boolean(selectedSubLocation)}
        site={selectedSubLocation}
        onSiteUpdate={onSiteUpdate}
        onHide={onSiteMapHide}
        pickerMode
        onPickerUnitSelect={onUnitSelect}
        excludedUnitIds={excludedUnitIds}
      />
    </>
  );
};

export default SiteMapUnitPicker;
